import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { InvoiceService } from '../../../providers/invoice.service';
import { UserService } from '../../../providers/user.service';
import { BaseComponent } from '../../shared/base/base.component';


@Component({
  selector: 'app-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss']
})

export class ItemComponent extends BaseComponent implements OnInit {
  items: any = [];
  user: any;

  ip: false;
  @Output() done: EventEmitter<object> = new EventEmitter<object>();

  constructor(public route: ActivatedRoute,
    public userService: UserService,
    public translator: TranslateService,
    public invoiceService: InvoiceService,
    public cookieService: CookieService,
    public titleService: Title,) {
    super(userService, translator, cookieService, titleService);

  }

  async ngOnInit() {
    await this.load();
  }
  load(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.userService.getItems(this.user.username, this.ip).subscribe((result: any) => {
        result.forEach(element => {
          element.quantity = 1;
          let item_group = this.items.find(obj => obj.group_name === element.item_group);
          if (!item_group) {
            item_group = {
              group_name: element.item_group,
              items: [element]
            };
            this.items.push(item_group);
          } else {
            item_group.items.push(element);
          }

        });
        resolve(result);
      }, error => {
        reject(error);
      });

    });
  }
  async addInvoice(item, quantity) {
    try {
      if (item.assigns && !item.selected) {
        throw new Error('ITEM_SERIAL_EMPTY_ERROR');
      }
      await this.invoiceService.addInvoice(this.selectedAccount, this.user.username, item.id, 'item', quantity, item.selected).toPromise();
      if (item.assigns) {
        item.assigns = item.assigns.filter(a => a.id != item.selected);
        item.selected = null;
      }
      this.handleSuccess();
    } catch (error) {
      this.handleError(error);
    }
  }

}

